

export type EndorsementsTypesValues = 'A' | 'C';

export enum ENDORSEMENTS_TYPES_VALUES {
    AUTOS = 'A',
    CALDERAS = 'C',
}